
import React, { useEffect, useState } from "react";
import { ReactComponent as CloseIcon } from "../assets/images/icons/ic-union.svg";
import styles from "./FAQCollapsible.module.css";
import Markdown from "react-markdown";
import rehypeRaw from 'rehype-raw';

const FAQCollapsible = React.forwardRef(({id, title = "", description, expanded = false, onExpand, style, disabled, textStyle, accentColor, onClick }, ref) => {
    const [exp, setExp] = useState(expanded);
    const [accentRgb, setAccentRgb] = useState(null);

    useEffect(() => {
        setExp(expanded ?? false);
    }, [expanded]);

    const toggleExpand = () => {
        if (!exp && onExpand && typeof onExpand === 'function') {
            onExpand();
        }
        setExp(!exp);
    };

    useEffect(() => {
        if (accentColor) {
            const rgb = accentColor.match(/\d+/g)?.map(Number);
            setAccentRgb(rgb);
        }   
    }, [accentColor]);

    return (
        <div className={styles.container} ref={ref} id={id} style={style} onClick={onClick}>
            <button className={`${styles.header} ${exp ? styles.expanded : ''}`} onClick={() => {
                if (!disabled) {
                    toggleExpand();
                }
            }}>
                <span style={{...textStyle, width: '100%'}}>{title}</span>
                <CloseIcon className={`${styles.closeIcon} ${exp ? styles.expanded : ''}`} style={{ '--accent-color': accentColor, '--accent-rgb': accentRgb }}></CloseIcon>
            </button>
            {exp &&
                <div className={styles.divider}></div>
            }
            <div className={`${styles.content} ${exp ? styles.expanded : ''}`}>
                {description &&
                    <Markdown rehypePlugins={[rehypeRaw]}>{description}</Markdown>
                }
            </div>
        </div>
    );
});

export default FAQCollapsible;
